import type { VendorDashboardResponse } from '@cravo/core'

export const PENDING_REQUESTS_EVENT = 'vendor:pending-requests'
export const NOTIFICATION_UNREAD_EVENT = 'vendor:notification-unread'
// Full dashboard payload broadcast by the layout-level poller
// (useDashboardPoller). Pages subscribe to keep their pending/scheduled
// lists live without each running their own interval.
export const DASHBOARD_DATA_EVENT = 'vendor:dashboard-data'

export function emitPendingRequestsCount(count: number) {
  window.dispatchEvent(
    new CustomEvent(PENDING_REQUESTS_EVENT, {
      detail: { count },
    }),
  )
}

export function emitDashboardData(data: VendorDashboardResponse, fetchedAt: number) {
  window.dispatchEvent(
    new CustomEvent(DASHBOARD_DATA_EVENT, {
      // `fetchedAt` = when the poller STARTED the request. Subscribers
      // compare it against their last local mutation so a payload that
      // pre-dates an accept/decline can't resurrect a removed card.
      detail: { data, fetchedAt },
    }),
  )
}

export function emitNotificationUnreadCount(count: number) {
  window.dispatchEvent(
    new CustomEvent(NOTIFICATION_UNREAD_EVENT, {
      detail: { count },
    }),
  )
}
